export default __webpack_public_path__ + "static/media/RIZ05053.8afa0932.JPG";